export const companyAnalysisKeys = {
	all: ['companyAnalysis'],
	// The IDs are sorted so identical sets in different order hit the same cache entry.
	analysis: (prospectQueryId, companyIds) => [
		...companyAnalysisKeys.all,
		'analysis',
		prospectQueryId,
		companyIds ? [...companyIds].sort() : companyIds,
	],
	results: (analysisId) => [...companyAnalysisKeys.all, 'results', analysisId],
};

export const companyAnalysisMutationKeys = {
	start: ['companyAnalysis', 'start'],
};
